<!--购销协议-->
<template>
    <div style="width: 740px;margin: 0 auto;border:1px solid;box-shadow: 5px 5px 5px #888888;">
        <div id="content" style="width: 640px;margin: 0 auto;">
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:right; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">合同编号：</span>
                <span class="content">{{contract.contractCode}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"> </span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:24pt; font-weight:bold">购销协议</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:14pt; font-weight:bold">北京果敢时代科技有限公司</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:18pt; font-weight:bold">与</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span class="content"
                      style="font-family:华文楷体; font-size:14pt; font-weight:bold">{{contract.partyBName}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span class="content">{{contract.year1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">年</span>
                <span class="content">{{contract.month1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">月</span>
                <span class="content">{{contract.day1}}</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">日</span>
            </p>
            <br style="clear:both; mso-break-type:section-break; page-break-before:always"/>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:16pt; font-weight:bold">购销协议</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">本《购销协议》（以下简称“<b>本协议</b>”）由以下双方在</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">北京市朝阳区</span>
                <span style="font-family:华文楷体; font-size:10.5pt">签署：</span>
            </p>

            <p style="margin:0pt"><span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>

            <p style="margin:0pt">
                <span style="font-family:华文楷体; font-size:10.5pt">甲方：</span>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">北京果敢时代科技有限公司</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span>
            </p>

            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:normal">乙方：</span>
                <span class="content">{{contract.partyBName2}}</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:normal">甲方和乙方以下单称为“<b>一方</b>”，合称为“<b>双方</b>”。</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">鉴于：</span>
            </p>

            <p style="margin:0pt 0pt 6pt 21pt; padding-left:14.45pt; text-indent:-14.45pt">
                <span style="font-family:宋体; font-size:10.5pt">A. 甲方基于转售目的拟向乙方采购产品，转售渠道和方式包括但不限于自行或委托其他主体通过网站、移动客户端终端及其他分销平台（“甲方平台”）向终端客户供应货物，或以其他方式向第三方进行销售；</span>
            </p>

            <p style="margin:0pt 0pt 6pt; text-indent:21pt">
                <span style="font-family:宋体; font-size:10.5pt">B. 乙方同意按照本协议的约定向甲方供应产品。 </span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; text-indent:24pt; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt">双方经友好协商，就产品购销事宜，达成如下协议：</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <ol type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:宋体; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 29.7pt; padding-left:2.5pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">定义</span>
                    <ol type="1" class="awlist1" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">产品</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">
                            指乙方依据本协议向甲方供应的货物，包括但不限于图书、服装、配饰、婴儿食品用品、美妆用品等，具体以《采购单》（见以下定义）中列明的为准。
                        </span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">终端客户</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">
                            指通过甲方或其转售方最终购买产品的人，为免疑义，该终端客户包括但不限于通过网络、移动客户端购买产品的人。
                        </span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">关联公司</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">
                           指任何受一方控制、控制该方或与该方受共同控制的公司或其他经营实体。为本协议之目的，“控制”指在一个实体中直接或间接拥有不低于50％的表决权。
                        </span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">平台规则</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">
                           指在甲方平台上发布和更新的各类规则文件。
                        </span>
                        </li>

                    </ol>
                </li>
            </ol>
            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>

            <ol start="2" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:宋体; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 29.7pt; padding-left:2.5pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">产品订购</span>
                    <ol type="1" class="awlist2" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">在本协议有效期内，甲方将通过签发<b>《采购单》</b>的方式向乙方订购产品，《采购单》可以包括以下形式：（1）甲方通过其供应商管理平台发出的采购指令；（2）</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件二《采购单》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">的形式；（3）甲方授权代理人采购的电子邮件。（“</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">《采购单》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">”）《采购单》应列明具体品牌、种类、型号、价格、送货时间、数量、价格、送货地点等。《采购单》及相应附件均是本合同不可分割的一部分，与本合同拥有同等法律效力，与之相关或因其引起的事项均应使用本合同约定，如《采购单》内容有调整，双方可按本条约定的方式中最后确认的《采购单》内容执行。任何乙方对甲方发出订单的单方面修改对甲方不具有约束力。</span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方以2.1中约定的形式之一向乙方发出《采购单》，乙方应在接到《采购单》后24小时内答复甲方，乙方逾期未提出异议或者未作任何表示的，视为订单已生效。甲方有权最晚在交付日前3天撤销或变更《采购单》，乙方应在撤销或变更通知后的24小时内提出异议或确认，在此期限内乙方未提出异议或者未作任何表示的，视为新《采购单》已生效，原《采购单》即作废，以此类推，乙方应按照最终生效的《采购单》交货。双方对撤销或变更时间另有书面约定的，从其约定。</span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方按照</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">《补充协议》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">指定的授权代理人进行业务沟通，各方联络人如有变更应及时通知对方，否则所产生的一切损失由违约方承担。</span>
                        </li>

                    </ol>
                </li>
            </ol>

            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>

            <ol start="3" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; margin:0pt 0pt 6pt 27.08pt; padding-left:5.12pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">产品质量</span>
                    <ol type="1" class="awlist3" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方向甲方交付的产品（包括赠品）应为其合法生产或有权经销的、符合国家质量标准或行业标准及双方约定的标准的、全新且未曾在其他渠道销售过的商品，该等商品不存在侵犯任何第三方权益或其他可能妨碍甲方销售的情况。该等商品质量应当符合甲方平台规则的相关要求。</span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">产品的质量须符合下列要求：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）产品不存在危及人身、财产安全的危险，符合保障人体健康和人身、财产安全的国家标准，行业标准；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）具备产品应当具备的使用性能，如使用性能存在瑕疵，须作出说明；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）符合在产品或者其包装上注明采用的产品标准，符合以广告、产品说明、实物样品等方式表明的该产品的质量状况；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）食品（包括成分及用量）需符合我国食品安全法及相关法律法规的标准和要求；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）其他特殊产品质量的国家标准。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">产品或者产品包装上的标识真实，并符合下列要求：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）有产品质量检验合格证明；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）商品应当按照法律法规的要求贴注条形码及中文标识，有中文标明的产品名称、成分及用量规格、等级、有效期、生产厂厂名和厂址等信息；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）限期使用的商品，在显著位置标明生产日期和安全使用期或失效日期；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）商品成分说明或原料表中对于特殊成分应当予以相应的说明；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）使用不当，容易造成产品本身损坏或者可能危及人身、财产安全的产品，有警示标志或者中文警示说明。其他需要事先让终端客户知晓的事项，在外包装上标明，或者预先向终端客户提供有关资料；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（6）其他关于产品包装标识的国家标准要求。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方保证不存在以下欺诈行为：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）在产品中掺杂、掺假、以假充真、以次充好或以不合格产品冒充合格产品；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）供应国家明令淘汰的产品或者失效、变质的产品；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）伪造产品的产地，伪造或者冒用他人的厂名、厂址，伪造或者冒用认证标志、名优标志等质量标志；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）依法需强制检验或认证的，未履行检验或认证手续或者伪造检验或认证结果；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（5）提供的产品中出现已拆封的产品或“空盒”产品（含缺少配件、说明书等随机附件）；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（6）乙方向甲方及终端客户提供有关产品或者服务的信息不真实，存在引人误解的虚假宣传，发布虚假广告或者欺骗、误导终端客户，使购买商品或者接受服务的终端客户的合法权益受到损害。</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（7）其他国家法律法规明文禁止的欺诈行为。</span>
                            </p>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>
            <ol start="4" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:宋体; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 29.7pt; padding-left:2.5pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">产品交付</span>
                    <ol type="1" class="awlist4" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方应按照最终生效《采购单》的要求，按时将产品交付至甲方指定地点。甲方在《采购单》中未明确指定交付日期的，乙方最晚应于收到《采购单》后10日内交货。双方对交货时间另有书面约定的，从其约定。货物发出后1个工作日内将发货信息（包括但不限于配送方名称、配送单号信息等）以书面方式通知甲方。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方应根据甲方在采购单中提出、甲方平台规则中提出或甲方向乙方通知的包装要求和指示对产品进行包装，并确保该等包装足以保护产品完整、清洁，适于储存、运输、销售和开封等后续用途；货物运输及包装等相关成本费用由乙方承担。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">凡有保质期的产品，如果产品规定的保质期大于六个月，则交付时剩余保质期不得少于完整保质期的二分之一；，如果产品规定的保质期小于六个月，则交付时剩余保质期不得少于完整保质期的三分之二。否则，甲方有权拒收。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">产品、吊牌及内外包装不得出现任何可能表明产品已在其他渠道销售过的标志或价格。如乙方对产品之前的价格标签未作处理,或对出现价格标签重叠、错粘或其他足以影响甲方商业信誉的任何标志及瑕疵未进行纠正，导致终端客户对甲方售卖的产品存在任何负面性误解或造成甲方遭受其他不利评价的，乙方应当为甲方消除影响并承担赔偿责任。如因此造成甲方对第三人承担任何法律责任，甲方承担责任后有权向乙方追偿。</span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方负责办理将产品交付至指定地点前所需相关的全部审批及报备手续并承担相应费用，交付产品时应一并交付有关许可或报备证明文件。产品为进口产品的，乙方应确保按照《海关法》等法律法规的要求履行了相应的进口程序及申报纳税（如有），乙方确保不存在逃避海关监管擅自将任何产品（包括赠品）运输、携带、邮寄入境的行为。</span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">基于甲方用于转售的目的，甲方有权要求乙方将产品直接交付至甲方指定的第三方，要求直接交付给第三方或产品经第三方签收不影响甲方依据本协议要求乙方承担的退换货及相关合同责任。</span>
                        </li>

                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt"> 产品毁损、灭失的风险在甲方接收前由乙方承担。</span>
                        </li>
                    </ol>
                </li>
            </ol>

            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>

            <ol start="5" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 27.08pt; padding-left:5.12pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">产品验收</span>
                    <ol type="1" class="awlist5" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方收到产品后仅对产品数量、外包装进行表面验收。对于乙方违约交付（包括不限于存在数量短溢，包装或产品破损、规格型号不符及其他质量瑕疵等）的，甲方有权当场拒收。甲方当场拒收的，乙方应自行保管并运回，甲方无义务提供保管服务。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方对产品的签收不视为对乙方产品质量或其履约行为的认可，不影响甲方在接收货物后有权要求乙方依协议约定退货或要求乙方采取其他处理措施的权利。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方拒收的产品，乙方应当按照甲方《采购单》的需求在甲方拒收后10日内补齐。</span>
                        </li>
                    </ol>
                </li>
            </ol>

            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>

            <ol start="6" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 27.08pt; padding-left:5.12pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">产品销售</span>
                    <ol type="1" class="awlist6" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">为了推广和销售产品，乙方应当向甲方提供产品的说明、图片以及其他相关资料，或提供产品供甲方拍摄图片，如有产品更改包装、图片等，应及时通知甲方更新资料，并且乙方保证甲方对这些资料的使用不会构成任何对第三方的侵权或已经取得了第三方的认可。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方保证，其应按甲方不时的要求，向甲方提供产品的相关介绍，包括但不限于书面说明、质检报告、授权文件等。乙方应当保证自身客服对接人员于每天9:00——21:00在线与甲方人员进行业务沟通。同时，若甲方及/或终端客户对乙方的产品有任何疑问，乙方至迟应在甲方提出要求后的12个小时内予以答复，并在24小时内使用官方账号进行口碑回复。如有必要，乙方应及时指派专人负责处理甲方转交的客户服务问题，并将服务电话（内部接口专用）及工作邮件（内部接口专用）提供给甲方。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方有权根据乙方请求决定为乙方提供市场营销服务、仓储物流服务、客户服务以及金融服务等增值服务，双方如需就该增值服务另行签署协议（该协议系甲方提供），乙方在此承诺接受该协议的全部内容并按照相关协议履行其义务。</span>
                        </li>
                    </ol>
                </li>
            </ol>

            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>

            <ol start="7" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 27.08pt; padding-left:5.12pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">退换货</span>

                    <ol type="1" class="awlist7" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方发现其提供的产品存在严重缺陷，即使正确使用仍然可能对人身、财产安全造成危害的，应当立即告知甲方，并采取有效防止危害的措施，包括但不限于召回。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">货物经甲方签收后，如果发现存在与合同约定不符、被终端客户退回或其他无法继续售卖的情形，且不论该不符情形是否发生在甲方签收前，亦不论该不符情形是否在甲方签收时已经指明，甲方有权要求乙方限期退货或更换，相关费用和风险由乙方承担，如乙方逾期不予退货或更换，甲方有权将货物退送至本协议</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">《补充协议》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">约定的乙方退货地点，退货运费及风险由乙方承担。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">在不限制甲方根据本协议享有的任何退货方式和补救办法的条件下，乙方接受甲方库存过剩或滞销品、残次品的退货。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">不论基于何种原因（包括但不限于产品质量问题、残次品、滞销品），甲方向乙方退换产品，乙方应按约定时间将产品调换到位或在【30】日内退还货款，如果需要账扣（包括产生的降价款）的，乙方应在【30】日内向甲方签署书面确认函。逾期未调换、未退还货款或未确认账扣的，经双方协商3日内没有明确处理方案的，甲方有权在下次货款结算中直接扣除。</span>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>
            <ol start="8" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 27.08pt; padding-left:5.12pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">货款</span><span
                        style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">结算</span>
                    <ol type="1" class="awlist8" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">双方确认的《采购单》上的价格为甲方向乙方应支付的最终价格，其中已经包括产品经甲方接收前产生的所有费用（包括不限于：材料费、包装费、人工费、运输费、装卸费、保险费、许可申报费、检验认证费、增值税等相关税费及产品的原厂商服务升级费用、保修和其他各项费用），除此以外，甲方无需再支付其他任何费用。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">进入结算期的可结算金额以甲方已到结算期的应付款扣除乙方逾期未付的降价款、退货款、商业折扣款、退残款、违约金、赔偿金以及其它乙方应支付的款项后的余额为准。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">结算账期及方式按照本协议<b>《补充协议》</b>约定执行。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方应就其提供的产品向甲方开具增值税专用发票。因乙方不具备一般纳税人身份而使其提供的增值税发票征收率低于其提供商品的税率的，差额部分直接从乙方货款中扣除。因乙方提供的产品属于法律、法规规定免征增值税项目的，可以不提供增值税专用发票。乙方发票填开的内容，应与其提供的产品内容完全一致，包括但不限于产品名称、型号、数量、单价等信息。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议终止时（无论任何原因），甲方有权继续留存最后一期应付乙方款项【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于商品违法、侵权、质量缺陷、商品宣传违规等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲乙双方可就最后一期应付乙方款项进行结算。否则，甲方有权直接从最后一期结算款项中扣除对应款项，最后一笔结算款项不足弥补甲方损失部分，乙方应继续承担相应赔偿责任。</span>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>
            <ol start="9" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 27.08pt; padding-left:5.12pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">保证金</span>
                    <ol type="1" class="awlist9" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方同意向甲方指定账户缴存一定金额（以下称“保证金”），用于担保其对本协议的履行和遵守，保证金金额和甲方保证金账户见</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">《补充协议》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方有权根据乙方经营情况随时调整保证金额度。如本协议为续签协议，甲乙双方同意，乙方根据双方签署的原《购销协议》及与其项下附件、补充协议（“<b>原协议</b>”）缴存的保证金余额继续适用于本协议。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">如乙方保证金额度调整或出现任何保证金被扣减情形，导致乙方保证金不足约定金额时，乙方同意甲方自应付乙方的任何款项中直接扣除差额，如甲方应付乙方款项不足弥补保证金差额，乙方应当于收到甲方通知之日起【10】日内将保证金补足。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">甲方可在以下情形发生时，处置保证金：</span>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（1）如因乙方产品违法、侵权、存在质量缺陷或违反本协议其他规定，造成终端用户任何损失的，甲方有权直接划扣保证金用于代乙方向终端用户退还货款、支付赔偿款；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（2）如乙方产品违法、侵权、存在质量缺陷或违反本协议其他规定，致使甲方及/或其关联公司权益受损（包括但不限于被行政处罚、被判决侵权、商誉受损等），甲方有权划扣保证金中的相应金额至甲方账户作为违约金和/或赔偿款；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（3）如乙方违反其与甲方或其关联公司的其他协议规定造成甲方或其关联公司损失或应支付违约金，乙方同意甲方可基于该协议规定直接划扣保证金中相应金额；</span>
                            </p>
                            <p style="margin:0pt 0pt 0pt 15pt; text-indent:-21pt">
                                <span style="font-family:华文楷体; font-size:10.5pt">（4）其他甲方有合法合理理由可处置保证金的情况。</span>
                            </p>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议履行期间，保证金的支配、使用权均归属于甲方。在乙方解散、清算、破产时，甲方享有对保证金的优先受偿权。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议终止时（无论任何原因），甲方有权继续留存保证金【3】个月。若本协议履行期间及本协议终止后，甲方未因乙方不履行或不完全履行本协议遭受损失（包括但不限于产品违法、侵权、质量缺陷等），或乙方已按本协议约定向甲方支付各项费用及欠款，则甲方将保证金余额无息退还乙方。</span>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>
            <ol start="10" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 32.2pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">乙方保证和承诺</span>
                    <ol type="1" class="awlist10" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方具有签订和履行本协议所需的所有合法资格、资质和能力，包括应持有中国法律法规所要求的一切证明、批准、许可和其他任何证明文件，而且应为商品的生产商或授权经销商，具体资质文件要求包括但不限于</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件一《乙方资质证明文件清单》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">所列事项。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方提供给甲方的产品来源正当合法，均为全新正品行货；乙方对其所提供产品享有唯一的合法的所有权，并且产品在本协议项下的推广和销售未侵犯任何第三方的权利，包括但不限于第三方的知识产权。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方向甲方提供的同款产品的供货价格不得高于提供给其他采购方的价格。乙方承诺甲方在进行商品活动时的销售价格应当不高于同期其他销售渠道同款产品的销售价格。乙方在产品价格发生任何变化时，应当经过甲方书面同意。</span>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>
            <ol start="11" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 32.2pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">知识产权</span>
                    <ol type="1" class="awlist11" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">与产品相关的专利、商标、名称、特有标识、装潢、技术秘密等均属于其权利人所有。乙方应保证其已按照法律规定或者合同约定获得了向甲方销售产品的权利或许可，该等权利或许可不与任何排他性权利相冲突，否则乙方应赔偿甲方因此而产生的任何经济损失。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方在此不可撤销地免费授权甲方 (并许可甲方对该权利进行再授权)，以推广乙方产品为目的，全部或部分地摘录、改编、翻译、复制、发布、展示或以其它任何合理方式使用乙方提供给甲方的任何信息和资料（包括但不限于商品商标、logo、商品信息、宣传资料、订单信息等)。</span>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt 0pt 6pt"><span style="font-family:宋体; font-size:10.5pt">&nbsp;</span></p>
            <ol start="12" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 32.2pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">保密</span>
                    <ol type="1" class="awlist12" style="margin:0pt; padding-left:0pt">
                        <ol type="1" class="awlist11" style="margin:0pt; padding-left:0pt">
                            <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                                <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                                <span style="font-family:华文楷体; font-size:10.5pt">任何一方均应对本协议内容，以及依据本协议而获得的对方的保密或专有信息（包括但不限于，与对方的技术、客户、商业计划、营销活动和财务有关的所有信息）（“<b>保密信息</b>”）严格保密，并且不得用于本协议以外目的，否则应对因此给对方造成的损失承担赔偿责任。</span>
                            </li>
                            <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                                <span style="font:7.0pt 'Times New Roman'">&nbsp; </span>
                                <span style="font-family:华文楷体; font-size:10.5pt">未经甲方及/或其关联公司同意，乙方不得使用甲方及/或其关联公司的任何商标、服务标识、品牌或其他知识产权，不得发布有关甲方及/或其关联公司或者本合同的任何新闻稿或其他公开文件，或在任何宣传资料中提及甲方及/或其他关联公司。</span>
                            </li>
                        </ol>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>
            <ol start="13" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 32.2pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">违约责任</span>
                    <ol type="1" class="awlist13" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方供应产品（包括赠品）不符合协议约定标准的（包括不限存在数量短溢、型号规格不符、未按期交货或其他质量瑕疵等）或违反本协议保证的，应承担该批次货款30%的违约金，违约金不足以弥补对甲方造成的损失的，乙方还应承担赔偿责任。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">如甲方发现乙方提供产品有本协议第3.4条规定的涉嫌欺诈的情形，甲方有权要求乙方支付假冒伪劣产品所涉整单订单总额十倍的违约金，违约金不足以弥补对甲方造成的损失的，乙方还应承担赔偿责任。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">乙方如果无法提供产品（包括赠品）的合法来源证明或提供虚假的授权资质文件，甲方有权经书面通知乙方后立即解除或终止本协议，乙方承担由此产生的法律责任并向甲方承担违约责任。如因此导致甲方遭受任何索偿、处罚或不利影响的，乙方应赔偿甲方遭受的全部损失。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">若因乙方违反本合同及其附件的有关规定而导致第三方向甲方予以索赔、主张权利、提出异议，乙方应当直接与该第三方交涉直至此事的解决，并赔偿甲方由此产生的全部损失，包括但不限于甲方因此所遭受的名誉损失。同时，乙方应按甲方的要求采取措施以停止侵害、恢复名誉、消除影响等。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议履行过程中，乙方保证乙方股东、实际控制人、董事、经理、业务负责人、雇员、代理人、受托人等（“<b>乙方代表</b>”）均严格履行本协议规定，并遵守甲方平台所公示之规则，乙方代表违反本协议任何内容的行为视为乙方违约行为，乙方应对此承担全部法律责任。甲方有权立即解除或提前终止本协议，同时免除甲方向乙方支付未结款项的义务。甲方因此遭受的损失，乙方应予以全部赔偿。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">针对乙方的违约行为，在不影响甲方依合同享有的其他权利和救济措施的情况下，甲方还有权视乙方违约情况要求退货、减少价款、赔偿损失、拒付或扣除相应款项或费用、提前终止或解除协议或采取其他法律许可或合同约定的一切救济措施。对于乙方依据本合同应向甲方承担的赔偿责任包括但不限于甲方遭遇主管部门的处罚、法院针对甲方判决的责任、甲方对客户的赔偿（不论该赔偿额是通过双方自愿和解确定还是经调解或判决确定）、诉讼费、律师费、鉴定费、差旅费等直接和间接损失，以及乙方依据合同应向甲方承担的应付款、违约金或赔偿金，甲方有权从应支付给乙方的款项中直接扣除。</span>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>
            <ol start="14" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 32.2pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">合同期限、解除</span>
                    <ol type="1" class="awlist14" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议有效期自签署之日起至【{{contract.contractYear}}】年【12】月【31】日止，合同期满双方同意续约但未签署书面续约合同或另行签订合同的，双方同意本协议期限自动延续三个月。三个月期满未签署续约协议的，本协议即终止。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">任何一方可在另一方严重违反本协议（包括本协议的附件、补充协议、平台规则）且收到守约方书面通知后十五（15)个工作日内未予以纠正时，书面通知另一方立即终止本协议；任何一方可以经提前六十（60）天向另一方发出书面通知而无因终止协议，乙方选择无因终止本协议的前提是乙方已经履行完毕其在本协议终止前已接受的订单。</span>
                        </li>
                    </ol>
                </li>
            </ol>
            <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>
            <ol start="15" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 32.2pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">通知</span>
                    <ol type="1" class="awlist15" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">任何与本协议有关的由一方发送给其他方的通知（“通知”）应当采用书面形式送达，并按照</span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">《补充协议》</span>
                            <span style="font-family:华文楷体; font-size:10.5pt">所列授权代理人的通讯地址/联系方式送达至被通知人。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">双方同意的通知方式包括EMS邮寄及电子邮件。</span>
                        </li>
                    </ol>
                </li>
            </ol>

            <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>
            <ol start="16" type="1" style="margin:0pt; padding-left:0pt">
                <li style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold; margin:0pt 0pt 6pt 32.2pt; text-indent:0pt">
                    <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">其他</span>
                    <ol type="1" class="awlist16" style="margin:0pt; padding-left:0pt">
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议受中华人民共和国法律管辖。对于因本协议而产生的任何争议，双方均应努力通过友好协商的方式进行解决。如无法就争议解决达成一致，任何一方均可向合同签订地人民法院提起诉讼。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议一方未经另一方事先书面同意不得将其本协议项下的权利和义务全部或部分转让给任何第三方。尽管有前述规定，乙方同意，甲方可将本协议（或其在本协议项下的任何权利或义务）转让给其关联公司，或当发生合并、重组、出售全部或重要资产或类似交易时转让给其后续公司。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议无论因任何原因终止，除协议中已有规定外，产品质量、知识产权、保密、保证和承诺、违约责任条款在协议终止后将继续有效。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">本协议内容包括协议正文、附件、补充协议以及甲方不时修订的平台规则。任何对本协议的修订一经生效即构成协议各方权利义务的补充，并成为本协议的一部分。本协议经双方授权代表签署并加盖双方公章或合同章后生效。本协议一式贰（2）份，甲乙双方各执壹（1）份，具有同等效力。</span>
                        </li>
                        <li style="font-family:华文楷体; font-size:12pt; font-weight:normal; list-style-position:inside; margin:0pt 0pt 6pt 10.35pt; text-indent:-21.25pt">
                            <span style="font-family:华文楷体; font-size:10.5pt">甲乙双方在本协议生效前签订的协议在本协议生效后即时终止。未完成事项可由双方参考本协议约定事项进行处理。</span>
                        </li>
                    </ol>
                </li>
            </ol>

            <p style="margin:0pt 0pt 6pt; text-align:justify">
                <span style="font-family:宋体; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:华文楷体; font-size:10.5pt"> </span>
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-style:italic">[以下部分无正文]</span>
            </p>

            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>
            <p style="margin:0pt 0pt 6pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt; width:464.3pt">
                <tr style="height:96.8pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">甲方（盖章）：北京果敢时代科技有限公司</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
                            <span class="content">{{contract.partyASignYear}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <span class="content">{{contract.partyASignMonth}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <span class="content">{{contract.partyASignDay}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">乙方（盖章）：</span>
                            <span class="content">{{contract.partyBTamped}}</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">&nbsp;</span>
                        </p>

                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">签约日期：</span>
                            <span class="content">{{contract.partyBSignYear}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">年</span>
                            <span class="content">{{contract.partyBSignMonth}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">月</span>
                            <span class="content">{{contract.partyBSignDay}}</span>
                            <span style="font-family:楷体; font-size:10.5pt">日</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:24.6pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <span class="content">{{contract.partyASignPersonal}}</span>
                        </p>
                    </td>
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:221.35pt">
                        <p style="font-size:10.5pt; line-height:115%; margin:6pt 0pt; orphans:0; widows:0">
                            <span style="font-family:楷体; font-size:10.5pt">授权代表人签字：</span>
                            <span class="content">{{contract.partyBSignPersonal}}</span>
                        </p>
                    </td>
                </tr>
            </table>
            <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>

            <p style="margin:0pt; text-align:center"><br style="page-break-before:always; clear:both"/>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件一 乙方资质证明文件清单</span>
            </p>
            <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>

            <table cellspacing="0" cellpadding="0"
                   style="border-collapse:collapse;float:left; margin:0pt 9pt; width:387.45pt">
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">文件名称</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">资质要求及涉及类别</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top;">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">1.</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                    <td colspan="4" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">基本资质证件</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.1</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">营业执照副本</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt;">
                        <p style="margin:0pt;orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">必须具有独立法人资格；如为分支机构，不具有独立法人资格，需提供总公司授权书；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.2</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">法定代表人身份证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内，正反面复印；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.3</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">税务登记证（三证合一后无需提供）</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.4</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">组织机构代码证（三证合一后无需提供）</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.5</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">一般纳税人认定证书</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.6</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">开户银行许可证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.7</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">商标注册证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">有效期内；</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.8</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">品牌授权销售代理协议或证明</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">如为品牌代理商，须提供生产商、品牌商或商标专有权人授权销售证明文件</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">1.9</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">进口货物报关单</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">海关出具的注有进口数量、成交总价的凭证</span>
                        </p>
                    </td>
                </tr>

                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top;">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">2.</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                    <td colspan="4" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                        <p style="margin:0pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold">特许经营资质文件</span>
                        </p>
                        <p style="margin:0pt; orphans:0; text-indent:68.25pt; widows:0"><span
                                style="font-family:华文楷体; font-size:10.5pt">&nbsp;</span></p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.1</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt;">
                        <p style="margin:0pt;padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证</span>
                        </p>
                    </td>
                    <td colspan="2"
                        style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt;">
                        <p style="margin:0pt;orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">食品</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.2</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">食品经营许可证、批次生产卫生检验报告或化验单、厂家卫生许可证、保健食品批准证书以及保健食品生产企业批准证书、进口保健食品批准证书（如为进口保健食品）</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">保健食品</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.3</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt; padding-bottom:2pt;orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">出版物经营许可证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">出版物、音像制品、电子出版物</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.4</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">医疗器械经营许可证</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">第二类医疗器械</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.5</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">批次化妆品检验报告；特殊用途化妆品卫生批准文件（如为特殊用途化妆品）；生产厂家卫生许可证复印件以及生产厂家生产许可证复印件</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">国产化妆品</span>
                        </p>
                    </td>
                </tr>
                <tr style="height:4.5pt">
                    <td style="padding-left:5.4pt;vertical-align:top;">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt;">2.6</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:146.34pt">
                        <p style="margin:0pt;padding-bottom:2pt; orphans:0; widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">进口化妆品卫生许可批件；进口化妆品厂家检验报告；进口检验检疫部门检验报告以及标签审核证书</span>
                        </p>
                    </td>
                    <td colspan="2" style="padding-left:5.4pt; padding-right:5.4pt; vertical-align:top; width:219.51pt">
                        <p style="margin:0pt; orphans:0;padding:0 0 2pt 68.25pt;widows:0">
                            <span style="font-family:华文楷体; font-size:10.5pt"></span>
                            <span style="font-family:华文楷体; font-size:10.5pt">进口化妆品</span>
                        </p>
                    </td>
                </tr>

            </table>


            <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span></p>
            <p style="margin:0pt; text-align:center"><br style="page-break-before:always; clear:both"/>
                <span style="font-family:华文楷体; font-size:10.5pt; font-weight:bold; text-decoration:underline">附件二 采购单</span>
            </p>

            <p style="margin:0pt">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&nbsp;</span>
            </p>

            <table cellspacing="0" cellpadding="0" style="border-collapse:collapse; margin-left:0pt">
                <tr>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <p style="margin:0pt; text-align:justify">
                            <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品名称</span>
                        </p>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <p style="margin:0pt; text-align:justify">
                            <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">计量单位</span>
                        </p>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <p style="margin:0pt; text-align:justify">
                            <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">商品单价（元）</span>
                        </p>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <p style="margin:0pt; text-align:justify">
                            <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">采购数量</span>
                        </p>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <p style="margin:0pt; text-align:justify">
                            <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">总价（元）</span>
                        </p>
                    </td>
                </tr>
                <tr v-for="goods in contract.purchaseGoodsList">
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <span>{{goods.goodsName}}</span>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <span>{{goods.goodsUnit}}</span>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <span>{{goods.goodsPrice}}</span>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <span>{{goods.goodsNumber}}</span>
                    </td>
                    <td style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:81.65pt">
                        <span>{{goods.goodsTotalMoney}}</span>
                    </td>
                </tr>
                <tr>
                    <td colspan="5"
                        style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:451.45pt">
                        <p style="margin:0pt; text-align:justify">
                            <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">合计（元）：</span>
                            <span>{{contract.purchaseTotalMoney}}</span>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td colspan="5"
                        style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:top; width:451.45pt">
                        <p style="margin:0pt; text-align:justify">
                            <span style="color:#ff0000; font-family:华文楷体; font-size:10.5pt; font-weight:bold">其他：</span>
                            <span>{{contract.purchaseOther}}</span>
                        </p>
                    </td>
                </tr>
            </table>

            <p style="margin:0pt; text-align:justify">
                <span style="font-family:'Times New Roman'; font-size:10.5pt; font-weight:bold">&nbsp;</span>
            </p>
        </div>
        <div style="padding:20px 0px 15px 0px;text-align: center">
            <el-button type="primary" @click="htmlPrint()">打 印</el-button>
            <el-button type="primary" @click="returnWindow()">返 回</el-button>
        </div>
    </div>
</template>
<script type="text/javascript">
    require('../../../../plugins/jquery.jqprint-0.3.js')
    export default {
        data () {
            return {
                contract: {
                    contractYear: "2019",
                    contractCode: "2017051400202323",
                    partyBName: "天津果敢时代科技有限公司",//乙方名称
                    year1: "2019",//第一个年
                    month1: "05",//第一个月
                    day1: "14",//第一个日
                    partyBName2: "天津果敢时代科技有限公司",//乙方名称2
                    partyBTamped: "天津果敢时代科技有限公司",//乙方盖章
                    partyASignYear: "2019",
                    partyASignMonth: "06",
                    partyASignDay: "23",
                    partyBSignYear: "2019",
                    partyBSignMonth: "04",
                    partyBSignDay: "21",
                    partyASignPersonal: "吴方华",
                    partyBSignPersonal: "李四",
                    purchaseTotalMoney: "200",
                    purchaseOther: "测试测试",
                    purchaseGoodsList: [
                        {
                            goodsName: "电视",
                            goodsUnit: "件",
                            goodsPrice: "1000",
                            goodsNumber: "2",
                            goodsTotalMoney: "2000"
                        }
                    ]
                }
            };
        },
        mounted () {
            var contentId = this.$route.query.contentId;
            var parentContractId = this.$route.query.parentContractId;
            var type = this.$route.query.type;
            this.parentContractId = parentContractId;
            this.initContent(contentId, type);
        },
        methods: {
            returnWindow(){
                window.close();
            },
            htmlPrint(){
                $("#content").jqprint();
            },
            initContent(contentId, type){
                var that = this;
                $.get({
                    url: '/suppliers/contract/template/content',
                    data: {
                        contentId: contentId,
                        type: type
                    },
                    success: function (result) {
                        if (!result.code) {
                            that.contract = result.data;
                            if (!that.parentContractId) {
                                if (!that.contract.contractYear) {
                                    that.contract.contractYear = "2017";
                                }
                            } else {
                                if (!that.contract.contractYear) {
                                    that.contract.contractYear = "2018";
                                }
                            }
                        } else {

                        }
                    }
                })
            }
        },
        computed: {
            amount: function () {
                return 200 - this.addForm.brandDesc.length;
            }
        }
    }

</script>
<style type="text/css" lang="less" scoped>
    input {
        border-width: 0px 0px 1pt 0px;
        border-bottom-color: #ff0000;
        text-align: center;
        font-size: 14px;
    }

    .awlist1 {
        counter-reset: awlistcounter1;
        list-style-type: none
    }

    .awlist1 li:before {
        content: "1." counter(awlistcounter1);
        counter-increment: awlistcounter1
    }

    .awlist2 {
        counter-reset: awlistcounter2;
        list-style-type: none
    }

    .awlist2 li:before {
        content: "2." counter(awlistcounter2);
        counter-increment: awlistcounter2
    }

    .awlist3 {
        counter-reset: awlistcounter3;
        list-style-type: none
    }

    .awlist3 li:before {
        content: "3." counter(awlistcounter3);
        counter-increment: awlistcounter3
    }

    .awlist4 {
        counter-reset: awlistcounter4;
        list-style-type: none
    }

    .awlist4 li:before {
        content: "4." counter(awlistcounter4);
        counter-increment: awlistcounter4
    }

    .awlist5 {
        counter-reset: awlistcounter5;
        list-style-type: none
    }

    .awlist5 li:before {
        content: "5." counter(awlistcounter5);
        counter-increment: awlistcounter5
    }

    .awlist6 {
        counter-reset: awlistcounter6;
        list-style-type: none
    }

    .awlist6 li:before {
        content: "6." counter(awlistcounter6);
        counter-increment: awlistcounter6
    }

    .awlist7 {
        counter-reset: awlistcounter7;
        list-style-type: none
    }

    .awlist7 li:before {
        content: "7." counter(awlistcounter7);
        counter-increment: awlistcounter7
    }

    .awlist8 {
        counter-reset: awlistcounter8;
        list-style-type: none
    }

    .awlist8 li:before {
        content: "8." counter(awlistcounter8);
        counter-increment: awlistcounter8
    }

    .awlist9 {
        counter-reset: awlistcounter9;
        list-style-type: none
    }

    .awlist9 li:before {
        content: "9." counter(awlistcounter9);
        counter-increment: awlistcounter9
    }

    .awlist10 {
        counter-reset: awlistcounter10;
        list-style-type: none
    }

    .awlist10 li:before {
        content: "10." counter(awlistcounter10);
        counter-increment: awlistcounter10
    }

    .awlist11 {
        counter-reset: awlistcounter11;
        list-style-type: none
    }

    .awlist11 li:before {
        content: "11." counter(awlistcounter11);
        counter-increment: awlistcounter11
    }

    .awlist12 {
        counter-reset: awlistcounter12;
        list-style-type: none
    }

    .awlist12 li:before {
        content: "12." counter(awlistcounter12);
        counter-increment: awlistcounter12
    }

    .awlist13 {
        counter-reset: awlistcounter13;
        list-style-type: none
    }

    .awlist13 li:before {
        content: "13." counter(awlistcounter13);
        counter-increment: awlistcounter13
    }

    .awlist14 {
        counter-reset: awlistcounter14;
        list-style-type: none
    }

    .awlist14 li:before {
        content: "14." counter(awlistcounter14);
        counter-increment: awlistcounter14
    }

    .awlist15 {
        counter-reset: awlistcounter15;
        list-style-type: none
    }

    .awlist15 li:before {
        content: "15." counter(awlistcounter15);
        counter-increment: awlistcounter15
    }

    .awlist16 {
        counter-reset: awlistcounter16;
        list-style-type: none
    }

    .awlist16 li:before {
        content: "16." counter(awlistcounter16);
        counter-increment: awlistcounter16
    }

    .content {
        font-family: 华文楷体;
        font-size: 10.5pt;
        border-bottom: 1px solid #ff4a7d;
    }
</style>


// WEBPACK FOOTER //
// contract_5.vue?05e8af90